export var FlowHieDocumentFormat;
(function (FlowHieDocumentFormat) {
    FlowHieDocumentFormat["ConsolidatedData"] = "ConsolidatedData";
    FlowHieDocumentFormat["ConsolidatedDataPdf"] = "ConsolidatedDataPdf";
    FlowHieDocumentFormat["ConsolidatedDataHtml"] = "ConsolidatedDataHtml";
    FlowHieDocumentFormat["BulkDownloadUrls"] = "BulkDownloadUrls";
})(FlowHieDocumentFormat || (FlowHieDocumentFormat = {}));
export const FLOW_HIE_CONSOLIDATED_FORMATS = [
    FlowHieDocumentFormat.ConsolidatedData,
    FlowHieDocumentFormat.ConsolidatedDataPdf,
    FlowHieDocumentFormat.ConsolidatedDataHtml,
];
export var FlowFhirResourceType;
(function (FlowFhirResourceType) {
    FlowFhirResourceType["All"] = "All";
    FlowFhirResourceType["AllergyIntolerance"] = "AllergyIntolerance";
    FlowFhirResourceType["Communication"] = "Communication";
    FlowFhirResourceType["Composition"] = "Composition";
    FlowFhirResourceType["Condition"] = "Condition";
    FlowFhirResourceType["Consent"] = "Consent";
    FlowFhirResourceType["Coverage"] = "Coverage";
    FlowFhirResourceType["Device"] = "Device";
    FlowFhirResourceType["DiagnosticReport"] = "DiagnosticReport";
    FlowFhirResourceType["DocumentReference"] = "DocumentReference";
    FlowFhirResourceType["Encounter"] = "Encounter";
    FlowFhirResourceType["FamilyMemberHistory"] = "FamilyMemberHistory";
    FlowFhirResourceType["Goal"] = "Goal";
    FlowFhirResourceType["Immunization"] = "Immunization";
    FlowFhirResourceType["Medication"] = "Medication";
    FlowFhirResourceType["Observation"] = "Observation";
    FlowFhirResourceType["Practitioner"] = "Practitioner";
    FlowFhirResourceType["Procedure"] = "Procedure";
    FlowFhirResourceType["Provenance"] = "Provenance";
    FlowFhirResourceType["RelatedPerson"] = "RelatedPerson";
    FlowFhirResourceType["ServiceRequest"] = "ServiceRequest";
})(FlowFhirResourceType || (FlowFhirResourceType = {}));
//# sourceMappingURL=enums.js.map